<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-tachometer"></i> India TA index Dashboard</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

<!--MRF Dashboard  -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                   <i class="fa fa-link"></i> MRF Dashboard
                </div>
                <div class="col-12 col-pn">
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                             <tr>
                           <th>Regions</th>
                           <th>Total</th>
                           <th>Raise / Pending For Approval</th>
                           <th>Approved</th>
                           <th>Assigned</th>
                           <th>Interview In Progress</th>
                           <th>shortlisted	</th>
                           <th>Offered	</th>
                           <th>Closed</th>
                           <th>Re-Open</th>
                           <th>On Hold</th>
                           <th>Rejected</th>
                           <th>Mrf not Required</th>
                        </tr>
                         </thead>
                         
                        <tbody>
                        <tr>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                        </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
             </div>

<!-- Overall Open Role(Replacement)  -->
             <div class="row row-replace m-t-10 menu-column">
                <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> Overall Open Role(Replacement)
                     </div>
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                        <tr>
                           <th>Regions</th>
                           <th>Total</th>
                           <th>0 - 7 days</th>
                           <th>8 - 15 days</th>
                           <th>16 - 30 days</th>
                           <th>31 - 60 days</th>
                           <th>Above 60 days</th>
                        </tr>
                         </thead>
                         
                        <tbody>
                        <tr>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                        </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
                <!-- <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> Semi-Skilled(Replacement)
                     </div>
                    <div class="table-responsive">
                       <table class="table table-align">
                        <thead>
                            <th>Regions</th>
                            <th>Total</th>
                            <th>0 - 7 days</th>
                            <th>8 - 15 days</th>
                            <th>Above 15 days</th>
                          </thead>
                          
                         <tbody>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                         </tbody>
                       </table>
                    </div>
                 </div> -->
             </div>
        
<!-- Unskilled(Replacement) and  Semi-Skilled(Replacement) -->
             <div class="row row-replace m-t-10 menu-column">
                <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> Unskilled(Replacement)
                     </div>
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                        <tr>
                           <th>Regions</th>
                           <th>Total</th>
                           <th>0 - 7 days</th>
                           <th>8 - 15 days</th>
                           <th>Above 15 days</th>
                        </tr>
                         </thead>
                         
                        <tbody>
                            <tr>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                        </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
                <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> Semi-Skilled(Replacement)
                     </div>
                    <div class="table-responsive">
                       <table class="table table-align">
                        <thead>
                        <tr>
                            <th>Regions</th>
                            <th>Total</th>
                            <th>0 - 7 days</th>
                            <th>8 - 15 days</th>
                            <th>Above 15 days</th>
                        </tr>
                          </thead>
                          
                         <tbody>
                             <tr>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                         </tbody>
                       </table>
                    </div>
                 </div>
             </div>

<!--Skilled(Replacement) and  Highly Skilled(Replacement) -->
             <div class="row row-replace m-t-10 menu-column">
                
                <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> Skilled(Replacement)
                     </div>
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                             <tr>
                           <th>Regions</th>
                           <th>Total</th>
                           <th>0 - 30 days</th>
                           <th>30 - 60 days</th>
                           <th>Above 60 days</th>
                        </tr>
                         </thead>
                         
                        <tbody>
                            <tr>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                           <td>0</td>
                        </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
                <div class="col-md-6 col-pn border-rad border">
                    <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                        <i class="fa fa-link"></i> Highly Skilled(Replacement)
                     </div>
                    <div class="table-responsive">
                       <table class="table table-align">
                        <thead>
                        <tr>
                            <th>Regions</th>
                            <th>Total</th>
                            <th>0 - 30 days</th>
                            <th>30 - 60 days</th>
                            <th>Above 60 days</th>
                        </tr>
                          </thead>
                          
                         <tbody>
                             <tr>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                         </tbody>
                       </table>
                    </div>
                 </div>
             </div>


      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

